import ApiRequest from '../../Decorators/ApiRequest';
import { TemplatesCategoriesResponse } from './Interfaces/TemplatesCategoriesResponse';
import { TemplateCategoryEntity } from '@entities/TemplateCategory/Types';
import { ApiResult } from '@shared/Interfaces/Api/ApiResult';
import { API_DEFAULT_HEADERS } from '@configs/ApiDefaultHeaders';
import { TemplateCategoryModel } from '@entities/TemplateCategory/TemplateCategotyModel';
import { RawTemplate } from '@entities/Template/Types';
import { GetTemplateDescriptionResponse } from './Interfaces/GetTemplateDescriptionResponse';
import { PurchaseTemplateResponse } from './Interfaces/PurchaseTemplateResponse';
import { PurchaseTemplateArguments } from './Interfaces/PurchaseTemplateArguments';

const BASE_URL = import.meta.env.VITE_BASE_URL_GUEST;
const BASE_URL_PURCHASE = import.meta.env.VITE_BASE_URL_PURCHASE;

export class TemplatesGateway {
    async getAllCategories(): Promise<ApiResult<TemplateCategoryEntity[]>> {
        try {
            const response = await ApiRequest(
                `${BASE_URL}/category/templates?page=1&perPage=3&templatesPage=1&templatesPerPage=100`,
                {
                    method: 'GET',
                    headers: API_DEFAULT_HEADERS,
                },
                false
            );

            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to get templates categories',
                };
            }
            const json: TemplatesCategoriesResponse = await response.json();
            const categories = Array.isArray(json.data)
                ? json.data.map(
                      rawCategory => new TemplateCategoryModel(rawCategory)
                  )
                : [];

            return {
                error: false,
                data: categories,
            };
        } catch (error) {
            return {
                error: true,
                message: `Failed to fetch categories: ${(error as Error).message}`,
            };
        }
    }

    async getTemplateById(templateId: number): Promise<ApiResult<RawTemplate>> {
        try {
            const response = await ApiRequest(
                `${BASE_URL}/templates/${templateId}?with[]=title&with[]=description&with[]=reviews`,
                {
                    method: 'GET',
                    headers: API_DEFAULT_HEADERS,
                }
            );

            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to get template information',
                };
            }
            const json: RawTemplate = await response.json();
            return {
                error: false,
                data: json,
            };
        } catch (error) {
            return {
                error: true,
                message: `Failed to fetch template: ${(error as Error).message}`,
            };
        }
    }

    async getTemplateDescription(
        description: string
    ): Promise<ApiResult<GetTemplateDescriptionResponse>> {
        try {
            const response = await ApiRequest(
                `${BASE_URL}/templates/description?path=${description}`,
                {
                    method: 'GET',
                    headers: API_DEFAULT_HEADERS,
                }
            );

            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to get template information',
                };
            }
            const json: GetTemplateDescriptionResponse = await response.json();
            return {
                error: false,
                data: json,
            };
        } catch (error) {
            return {
                error: true,
                message: `Failed to fetch template description: ${(error as Error).message}`,
            };
        }
    }

    async purchaseTemplate(
        body: PurchaseTemplateArguments
    ): Promise<ApiResult<PurchaseTemplateResponse>> {
        try {
            const response = await ApiRequest(`${BASE_URL_PURCHASE}`, {
                method: 'POST',
                headers: API_DEFAULT_HEADERS,
                body: JSON.stringify(body),
            });

            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to purchase template',
                };
            }
            const json: PurchaseTemplateResponse = await response.json();
            return {
                error: false,
                data: json,
            };
        } catch (error) {
            return {
                error: true,
                message: `Failed to purchase template: ${(error as Error).message}`,
            };
        }
    }
}
